import styled from '@emotion/styled';

import { getColor } from '../../common/UICommon';
import { TabletWidth } from '../../../global.style';

export const ProductContainer = styled.div<{ isPicked?: boolean }>`
  background-color: ${getColor('WHITE')};
  border-radius: 24px;
  border: 1px solid ${getColor('BEIGE_2')};
  text-align: left;
  width: 330px;
  padding: 24px 16px;
  cursor: pointer;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -${({ isPicked }) => (isPicked ? 3 : 1)}px;
    left: -${({ isPicked }) => (isPicked ? 3 : 1)}px;
    right: -${({ isPicked }) => (isPicked ? 3 : 1)}px;
    bottom: -${({ isPicked }) => (isPicked ? 3 : 1)}px;
    border-radius: 24px;
    border: ${({ isPicked }) =>
      isPicked ? `3px solid ${getColor('PURPLE_100')}` : `1px solid ${getColor('GRAY_20')}`};
    pointer-events: none;
  }

  @media (max-width: ${TabletWidth}px) {
    width: 100%;
    max-width: 330px;
  }
`;

export const ProductTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  align-items: center;
`;

export const ProductTitle = styled.p`
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  color: ${getColor('BLACK')};
`;

export const ProductMostPopularBadge = styled.div`
  background-color: ${getColor('HIGHLIGHT_100')};
  border-radius: 4px;
  padding: 2px 8px;
  color: ${getColor('GRAY_95')};
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
`;

export const ProductLabel = styled.span<{ withPaddingBottom: boolean }>`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: ${getColor('PURPLE_PAYWALL_60')};
  margin-bottom: 16px;
  display: flex;
  align-items: baseline;
  white-space: pre-wrap;
  ${({ withPaddingBottom }) => withPaddingBottom && 'padding-bottom: 4px;'}
`;

export const ProductLabelWeekly = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
`;

export const ProductPriceContainer = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid ${getColor('GRAY_40')};
  padding-top: 16px;
`;
export const ProductPriceLeft = styled.div`
  display: flex;
  color: ${getColor('BLACK')};
  align-items: baseline;
  width: 50%;
`;

export const ProductPriceBig = styled.div`
  font-size: 48px;
  font-weight: 400;
  line-height: 56px;
`;

export const ProductPriceSmall = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin-left: 4px;
`;
export const ProductPriceRight = styled.div`
  color: ${getColor('BLACK')};
  width: 50%;
`;

export const ProductPriceRightBig = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
`;

export const ProductPriceRightSmall = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
`;
